<template>
  <div>
    <ValidationObserver ref="observer">
      <Menu />
      <pulse-loader
        :loading="loading"
        :color="color"
        :size="size"
        class="vue-loader"
      ></pulse-loader>
      <div class="container main">
        <div class="row">
          <div class="col-md-12">
            <SectionTitle
              title="Gerenciar usuários"
              description="Edita as informações de um usuário"
              url="/administracao"
              modalDocument="DocGerenciarUsuario"
            />
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label for="">Nome ou CPF</label>
              <!-- <input
                type="text"
                class="form-control"
                placeholder=""
                v-model="nome"
                autocomplete="off"
              /> -->
              <vue-select
                :options="usuariosSelect"
                label="nome"
                placeholder=""
                @input="onChangeUsuariosSelect"
                :filter="filterLabel"
              >
                <template slot="option" slot-scope="option">
                  {{ option.nome }} - {{ option.cpf }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="col-md-3">
            <label for="">Status</label>
            <div class="form-group">
              <select
                name=""
                id=""
                class="form-control"
                @change="onChangeStatus($event)"
              >
                <option value="todos">Todos</option>
                <option value="1">Ativo</option>
                <option value="0">Inativo</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="">Perfil</label>
            <div class="form-group">
              <select
                name=""
                id=""
                class="form-control"
                @change="onChangePerfil($event)"
              >
                <option value="todos">Todos</option>
                <option value="Administrador e-SUS PEC">
                  Administrador e-SUS PEC
                </option>
                <option value="Agente Comunitário de Saúde">
                  Agente Comunitário de Saúde
                </option>
                <option value="Aux/Téc Enfermagem">Aux/Téc Enfermagem</option>
                <option value="Gerente/Coordenador(a)">
                  Gerente/Coordenador(a)
                </option>
                <option value="Coordenador(a) de UBS">
                  Coordenador(a) de UBS
                </option>
                <option value="Enfermeiro(a)">Enfermeiro(a)</option>
                <option value="Médico(a)">Médico(a)</option>
                <option value="Odontólogo(a)">Odontólogo(a)</option>
                <option value="Recepcionista">Recepcionista</option>
                <option value="Secretário(a)">Secretário(a)</option>
                <option value="Agente Comunitário de Endemias (ACE)">
                  Agente Comunitário de Endemias (ACE)
                </option>
                <option value="Coordenador(a) de Vigilância em Saúde">
                  Coordenador(a) de Vigilância em Saúde
                </option>
                <option value="Coordenador(a) de Imunização">
                  Coordenador(a) de Imunização
                </option>
                <option value="Vacinador(a)">Vacinador(a)</option>
                <option value="Téc. Aux de Saúde Bucal">
                  Téc. Aux de Saúde Bucal
                </option>
                <option value="Profissional da eMulti">
                  Profissional da eMulti
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="info-table">
              <div class="info-table-item">
                <b>Total:</b> {{ total_de_registros_da_tabela }} usuários
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <table
              class="table table-responsive table-striped gerenciar-usuarios"
              id="table"
            >
              <thead class="thead-light">
                <tr>
                  <th>CPF</th>
                  <th>Nome</th>
                  <th>Função</th>
                  <th>Status</th>
                  <th>Nova senha</th>
                  <th>
                    Informar pelo WhatsApp?
                    <span
                      v-b-tooltip.hover.right
                      title='Ao selecionar a opção "SIM", será enviado automaticamente todo mês, via WhatsApp cadastrado, um aviso sobre: Reprovação de dados no SISAB; Classificação das equipes; Suspensão de recursos do cofinanciamento federal e outros. Destinatários: Parceiros, Administradores do e-SUS PEC, Secretários e Coordenadores municipais.'
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in displayedUsuarios" :key="index">
                  <td>{{ item.cpf }}</td>
                  <td>{{ item.nome }}</td>
                  <td>
                    {{ item.funcao }}
                  </td>
                  <td>
                    <select
                      name="funcao"
                      class="form-control"
                      id=""
                      v-model="item.status"
                    >
                      <option value="1">Ativo</option>
                      <option value="0">Inativo</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="password"
                      class="form-control"
                      v-model="item.nova_senha"
                    />
                  </td>
                  <td>
                    <div
                      class="whatsapp-actions"
                      v-if="
                        $store.state.infoMunicipio.parceiro == null &&
                        (item.id_funcao == 1 ||
                          item.id_funcao == 2 ||
                          item.id_funcao == 7)
                      "
                    >
                      <b-form-radio v-model="item.nao_receber_msg" value="0"
                        >Sim</b-form-radio
                      >
                      <b-form-radio v-model="item.nao_receber_msg" value="1"
                        >Não</b-form-radio
                      >
                    </div>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn-table"
                      style="color: #fff"
                      v-on:click="editarUsuario(item)"
                    >
                      Salvar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <pagination
              :page="page"
              :pages="pages"
              v-on:update:page="page = $event"
            >
            </pagination>
          </div>
        </div>
      </div>
      <Footer />
    </ValidationObserver>
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Pagination from '@/components/utils/Pagination'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  name: 'GerenciarUsuario',
  metaInfo: {
    title: 'Gerenciar usuários',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
    Pagination,
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    displayedUsuarios() {
      this.setPages(this.usuarios)
      this.total_de_registros_da_tabela = this.usuarios.length
      return this.paginate(this.usuarios)
    },
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      usuarios: [],
      funcao: '',
      status: '',
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nova_senha: '',
      usuariosOriginais: [],
      usuariosSelect: [],
    }
  },
  created() {
    this.buscarUsuarios()
  },
  methods: {
    setPages(usuarios) {
      let numberOfPages = Math.ceil(usuarios.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    paginate(usuarios) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return usuarios.slice(from, to)
    },

    filterLabel(options, search) {
      return options.filter((item2) => {
        if (
          item2.nome.toUpperCase().indexOf(search.toUpperCase()) > -1 ||
          item2.cpf.toUpperCase().indexOf(search.toUpperCase()) > -1
        ) {
          return true
        }
        return false
      })
    },

    onChangeUsuariosSelect(item) {
      this.page = 1
      if (item != null) {
        let filtro = this.usuariosOriginais.filter((item2) => {
          if (item2.nome == item.nome || item2.cpf == item.cpf) {
            return true
          }
          return false
        })
        this.setPages(filtro)
        this.total_de_registros_da_tabela = filtro.length
        this.paginate(filtro)
        this.usuarios = filtro
      } else {
        this.usuarios = this.usuariosOriginais
      }
    },

    onChangeStatus(item) {
      if (item.target.value != 'todos') {
        this.usuarios = this.usuariosOriginais.filter((el) => {
          return el.status == item.target.value
        })
      } else {
        this.usuarios = this.usuariosOriginais
      }
    },

    onChangePerfil(item) {
      if (item.target.value != 'todos') {
        this.usuarios = this.usuariosOriginais.filter((el) => {
          return el.funcao == item.target.value
        })
      } else {
        this.usuarios = this.usuariosOriginais
      }
    },

    buscarUsuarios() {
      this.loading = true
      this.$api
        .get('/app/usuarios/' + this.$store.state.cod_ibge)
        .then((response) => {
          this.loading = false
          this.usuariosOriginais = response.data
          this.usuarios = response.data
          this.usuariosSelect = response.data
        })
        .catch(function (error) {
          console.log(error)
          this.loading = false
        })
    },

    async editarUsuario(item) {
      if (item.nova_senha) {
        const hasUpperCase = (str) => {
          return str.toLowerCase() !== str
        }
        let isValid = true
        const symbolRegex = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
        if (item.nova_senha.length < 8) isValid = false
        if (!symbolRegex.test(item.nova_senha)) isValid = false
        if (!hasUpperCase(item.nova_senha)) isValid = false

        if (!isValid) {
          this.$toast.error(
            'Senha deve conter 8+ caracteres, com no mínimo 1 letra maiúscula e 1 caractere especial.',
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }
      }

      let rsp = confirm('Deseja editar este usuário?')
      if (rsp == true) {
        this.loading = true
        let url = '/app/usuario/gerenciar'
        this.$api
          .post(url, item)
          .then((response) => {
            if (response.data.error == true) {
              this.$toast.error(response.data.message, 'Error:', {
                position: 'topRight',
              })
              this.loading = false
            } else {
              this.$toast.success(response.data.message, 'Sucesso:', {
                position: 'topRight',
              })
              this.loading = false
            }
          })
          .catch(function (error) {
            this.loading = false
            console.log(error)
          })
      }
    },
  },
}
</script>

<style lang="scss">
.gerenciar-usuarios {
  td {
    font-size: 13px !important;
    .whatsapp-actions {
      display: flex;
      gap: 15px;
    }
    select,
    input {
      width: auto;
    }
  }
}
</style>
